const DOMAIN_NAME = 'activityLog';

// Route ID for Activity Log menu
const ACTIVITY_LOG_ROUTE_ID = 43;

const ROWS_PER_PAGE = 15;

const MODULE_FILTER_OPTIONS = [
    { value: null, label: 'All Modules' },
    { value: 'leave', label: 'Leave' },
    { value: 'role', label: 'Role' },
    { value: 'user', label: 'User' },
    { value: 'employee', label: 'Employee' },
    { value: 'profile-change-request', label: 'Profile Change' },
    { value: 'kpi', label: 'KPI' }
];

export {
    DOMAIN_NAME,
    ACTIVITY_LOG_ROUTE_ID,
    ROWS_PER_PAGE,
    MODULE_FILTER_OPTIONS
};
